<template>
  <div class="listPage">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button
          class="addBtn"
          @click="showDialog()"
          v-if="null !== addPermission"
        >{{ addPermission.name }}
        </el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.keywords"
              placeholder="关键词"
              @keyup.enter.native="handleCurrentChange(1)"
            >
              <div slot="suffix" class="searchClass" @click="handleCurrentChange(1)">搜索</div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="配置名"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="configKey"
          label="配置标识"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="configValue"
          label="配置值"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <span>{{scope.row.type === 2? Math.trunc(scope.row.configValue / 24) +'天' + scope.row.configValue % 24+'小时': scope.row.configValue}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="updatedTime"
          label="更新时间"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="40"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'config-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #0083fd;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="editBtn"
                >{{ button.name }}
                </el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="44%"
      id="userPage"
      class="commonScrollDialog userPage"
    >
      <div class="scrollContainer">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          @submit.native.prevent
          label-width="100px"
        >
          <div class="rowClass">
            <el-form-item label="配置名" prop="name">
              <el-input
                auto-complete="off"
                v-model="form.name"
                placeholder="请填写配置名"
                class="inputClass"
                clearable
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="配置标识" prop="configKey">
                <el-input
                  v-model="form.configKey"
                  disabled
                  placeholder="请填写配置标识"
                  class="inputClass"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="配置单位" prop="unit">
              <el-input
                auto-complete="off"
                v-model="form.unit"
                maxlength="20"
                class="inputClass"
                clearable
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              :rules="[
              { required: true, message: '请输入配置值', trigger: 'blur' },
              ]"
              v-if="form.type === 1" label="配置值" prop="configValue">
              <el-input
                auto-complete="off"
                v-model="form.configValue"
                placeholder="请填写配置值"
                class="inputClass"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :rules="[
              { required: true, message: '请输入配置值(数字)', trigger: 'blur' },
              { type: 'number', min:0, message: '请输入有效的数字', trigger: 'blur' }
              ]" v-if="form.type === 2" label="天" prop="configValueDay">
              <el-input
                auto-complete="off"
                v-model.number="form.configValueDay"
                placeholder="请填写配置值"
                class="inputClass"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true, message: '请选择配置项', trigger: 'change'}" v-if="form.type === 3" label="配置值" prop="configValue">
              <el-select
                v-model="form.configValue"
                placeholder="请选择"
                class="inputClass"
                popper-class="adminHomeSelect"
                clearable
              >
                <el-option label="红色" value="red"></el-option>
                <el-option label="蓝色" value="blue"></el-option>
              </el-select>
            </el-form-item>

          </div>
          <div class="rowClass">
            <el-form-item :rules="[
              { required: true, message: '请输入配置值(数字)', trigger: 'blur' },
              { type: 'number',min:0, message: '请输入有效的数字', trigger: 'blur' }
              ]" v-if="form.type === 2" label="小时" prop="configValueHour">
              <el-input
                auto-complete="off"
                v-model.number="form.configValueHour"
                placeholder="请填写配置值"
                class="inputClass"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('form')"
            class="confirmBtn"
            :loading="loading"
          >确 定
          </el-button
          >
          <el-button @click="dialogVisible = false" class="cancelBtn"
          >取 消
          </el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {getAllKey} from "@/assets/js/tree/tree.js";
import BasicForm from "../../../common/BasicForm.vue";
import {postJsonRequest} from "../../../axios/api";


export default {
  name: "user",
  props: ["menuId"],
  data() {
    let validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写密码~"));
      } else {
        if (this.form.confirmPassword) {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validateConfirmPassword = (rule, value, callback) => {
      value = this.form.confirmPassword;
      if (!value) {
        callback(new Error("请确认密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (value) {
        let regPhone = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/; //11位手机号码正则
        if (!regPhone.test(value)) {
          callback(new Error("手机号格式不正确"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请填写手机号"));
      }
    };
    let checkEmail = (rule, value, callback) => {
      // 如果值为空，直接通过验证（不必填）
      if (!value) {
        return callback();
      }
      // 邮箱正则表达式（宽松匹配常见邮箱格式）
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailReg.test(value)) {
        callback(new Error("请输入正确的邮箱格式"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogVisible: false,
      title: "添加用户",
      addPermission: null,
      buttonList: [],

      queryForm: {
        keywords: "",
      },
      form: {
        name: "",
        configKey: "",
        configValueDay: "",
        configValueHour: "",
      },
      rules: {
        name: [
          {required: true, message: "请填写配置名", trigger: "blur"},
        ],
        configKey: [
          {required: true, message: "请填写配置标识", trigger: "blur"},
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
      disabled: false,
      imageType: "image/jpeg,image/png",
      file: "",
      imageUrl: "",
      roles: [],
      userNoDisable: false,
      departments: [],
      stations: [],
      total: 0, //总条数
      tableData: [],
      current: 1, //当前页数
      size: 6, //显示几条
      tableHeight: 500, // 表格高度
    };
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    getTableHeight() {
      let tableH = 305; // 除表格外其他区域高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = tableHeightDetil;
      }
    },
    //跳出弹框
    showDialog() {
      this.userNoDisable = false;
      this.dialogVisible = true;
      this.title = "添加用户";
      this.imageUrl = "";
      this.disabled = false;
      this.form = {};
      // this.permission = "";
      // this.getStations();
    },
    //获取权限树
    getPermissionTree() {
      this.postJsonRequest("/user-server/api/u-permission/query", {
        removed: 0,
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.dataOfTree = data;
          let dataStr = JSON.stringify(data); //将json对象转换成字符串
          let splitArr = dataStr.split('"name":');
          let len = splitArr.length;
          this.totalTreeNum = len == 0 ? 0 : len - 1;
          let permission = this.permission;
          if (permission) {
            let oldArr = permission.split(",");
            this.checkedNum = oldArr.length;
            this.$refs.tree.setCheckedKeys(
              getAllKey(data, "id", "children", oldArr),
              true
            ); //重点是这句话，将所需要的数据转换成想要的数据
          } else {
            this.checkedNum = 0;
            this.handleCheckAllChange(false);
          }
          if (this.totalTreeNum <= this.checkedNum) {
            this.handleCheckAllChange(false);
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取权限失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    //全选
    handleCheckAllChange(val) {
      if (val) {
        this.$refs.tree.setCheckedNodes(this.systemMenuModeTree);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    //获取选中和半选中状态下的数据
    handleCheckChange() {
      let res = this.$refs.tree
        .getCheckedNodes()
        .concat(this.$refs.tree.getHalfCheckedNodes());
      let checkedNum = res.length;
      this.checkedNum = checkedNum;
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.form.stationId = selectInfo[1];
      }
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const multiData = this.form;
            if(this.form.type === 2){
              multiData.configValue = this.form.configValueDay*24 + this.form.configValueHour
            }
            if (this.form.id) {
              //编辑
              this.update(multiData);
            } else {
              //新增
              this.save(multiData);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 新增
    save(form) {
      this.uploadFileRequest("/user-server/api/u-user/save", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.imageUrl = "";
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 查询
    query(queryType) {
      try {
        this.loading = true;
        let params = {};
        let current = 1;
        let size = 6;
        params = {...this.queryForm};
        current = this.current;
        size = this.size;
        this.getRequest(
          "/user-server/systemConfig/queryAll?current=" + current + "&size=" + size+ "&keyword=" + params.keywords,
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (queryType === "queryById") {
              this.form = data.records[0];
              this.form.confirmPassword = this.form.password;
              this.form.sex = String(this.form.sex);
              if (this.form.iconUrl) {
                this.imageUrl = "/minio/" + this.form.iconUrl;
                this.disabled = true;
              }
              if (this.form.areaId && this.form.stationId) {
                this.form.areaInfo = [
                  parseInt(this.form.areaId),
                  parseInt(this.form.stationId),
                ];
              }
            } else {
              this.tableData = data.records;
              this.total = data.total;
            }
          } else if (oData.code != 401) {
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    //编辑
    edit(data) {
      this.dialogVisible = true;
      this.title = "编辑配置";
      // data.type === 2?data.configValue = Number(data.configValue):''
      delete data.updatedTime;
      data.type === 2?this.form =  {...data,configValueHour:Number(data.configValue%24),configValueDay:Number(Math.trunc(data.configValue / 24))}:this.form =  {...data};
      this.disabled = false;
    },
    // 编辑
    update(form) {
      this.postJsonRequest("/user-server/systemConfig/updateConfig", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    //删除
    del(id) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest("/user-server/api/u-user/delete?id=" + id).then(
            (res) => {
              let oData = res.data;
              if (oData.code == 0) {
                let totalPage = Math.ceil((this.total - 1) / this.size);
                let currentPage =
                  this.current > totalPage ? totalPage : this.current;
                this.current = currentPage < 1 ? 1 : currentPage;
                this.query();
                this.$message({
                  message: "删除成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {
                  },
                });
              } else if (oData.code != 401) {
                let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
                this.$confirm(tips, "提示", {
                  confirmButtonText: "好的",
                  customClass: "customClass-style",
                  iconClass: "",
                  dangerouslyUseHTMLString: true,
                  confirmButtonClass: "confirm-style",
                  showCancelButton: false,
                });
              }
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "user-add") {
              this.addPermission = child;
            } else if (child.path !== "user-view") {
              otherButton.push(child);
            } else if (child.path !== "user-open") {
              otherButton.push(child);
            } else if (child.path !== "user-close") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    this.getTableHeight();
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
/* 上传图片样式 */
.searchClass {
  width: 51px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #00aeff;
  line-height: 16px;
  margin-top: 10px;
  border-left: 1px solid #00aeff;
}

.avatar-uploader {
  width: 120px;
  height: 120px;
  background: rgba(10, 5, 0, 0.50);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.uploaded-image {
  width: 120px;
  max-height: 120px;
}

.el-upload__tip {
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #fff;
  line-height: 14px;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-placeholder .upload-text {
  font-size: 16px;
  color: #00AEFF;
}

>>> .el-dialog__header {
  /* background-image: url(../../img/common/tableHead.png); */
  /* background-position: 15px 13px;
  background-repeat: no-repeat;
  background-size: 300px 35px; */
  /* padding: 20px 20px 0px 40px ; */
  background: url(../../../assets/img/2dmap/pop_bg.png) no-repeat;
  background-position: 6px 25px;
}

.deleteButton {
  margin-top: -51.5px;
  margin-bottom: 25px;
}

.rowClass {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: auto 30px;
}

.rowClass .right {
  margin-left: -34px;
}

.adminHomeContainer
.el-tabs
.el-tabs__content
.commonScrollDialog
.el-dialog
.el-dialog__body
.el-form
.rowClass
.el-form-item {
  /* width: 270px; */
}

.darkAdminHomeContainer
.el-tabs
.el-tabs__content
.commonScrollDialog
.el-dialog
.el-dialog__body
.el-form
.rowClass
.el-form-item {
  /* width: 270px; */
}

/* .inputClass {
  width: 270px !important;
} */
/* .labelClass {
  display: flex;
  flex-direction: row;
}
.numClass {
  color: #0083fd;
}
.el-checkbox:last-of-type {
  float: right;
  margin-top: -11px;
}
.treeClass {
  margin: 0 auto;
  margin-top: -35px;
  width: 568px;
  height: 126px;
  background: #ececec;
  border: 1px solid #dadada;
  border-radius: 6px;
  overflow: auto;
}
.el-tree {
  background: transparent;
} */
.avatorClass {
  position: relative;
}

.el-upload__tip {
  position: absolute;
  top: 0%;
  left: 125px;
  width: 300px;
}
</style>




// WEBPACK FOOTER //
// src/components/admin/user/config.vue